// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"mb","modalContent":"nb","header":"ob","close":"pb"};